import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Contact3DWindow } from './Contact3DWindow';
import { GameIndexContext, TestingModeContext } from '../../core/util/Context';
import { Navigate, useParams } from 'react-router-dom';
import { REDIRECT_GAME_ID, USERNAME_KEY } from '../../core/util/LocalStorageKeys';
import { GameContextProvider } from '../../core/util/GameContextProvider';
import { DebugContextProvider } from '../../../core/util/Debug';
import { OverlayContextProvider, OverlayRoot } from '../../core/components/OverlayContainer';
export const Contact3DPage = () => {
    const { gameId } = useParams();
    if (gameId === undefined) {
        throw new Error('GameId undefined in params!');
    }
    const username = localStorage.getItem(USERNAME_KEY);
    if (username === undefined || username === null || username.length === 0) {
        sessionStorage.setItem(REDIRECT_GAME_ID, gameId);
        return _jsx(Navigate, { to: '/', replace: true });
    }
    return (_jsxs(OverlayContextProvider, { children: [_jsx(TestingModeContext.Provider, { value: false, children: _jsx(GameIndexContext.Provider, { value: 0, children: _jsx(DebugContextProvider, { value: { gameIndex: 0 }, children: _jsx(GameContextProvider, { isTestingMode: false, fallback: _jsx(_Fragment, {}), username: username, desiredGame: gameId, gameIndex: 0, children: _jsx(Contact3DWindow, { username: username, gameId: gameId }) }) }) }) }), _jsx(OverlayRoot, {})] }));
};
//# sourceMappingURL=Contact3DPage.js.map